import { Suspense } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import Image from './Image';
import { useDesignContext } from '../providers/DesignContextProvider';

export function SuspenseImage(
  {
    src,
    alt,
    className,
    loaderClassName
  }
) {
  const { ImageLoader } = useDesignContext();
  return (
    <Suspense
      fallback={(
        <div
          className={classNames(
            loaderClassName || className,
            'overflow-hidden'
          )}
          style={{
            flex: '0 0 auto'
          }}
        >
          <ImageLoader />
        </div>
      )}
    >
      <Image src={src} alt={alt} className={className} />
    </Suspense>
  );
}

SuspenseImage.propTypes = {
  src: PropTypes.string.isRequired,
  alt: PropTypes.string,
  className: PropTypes.string,
  loaderClassName: PropTypes.string
};

export default SuspenseImage;
